import React, { useCallback, useEffect, useState } from "react";
import "../styles/partner.css";
import default_image from "../assets/images/default.png";
import { Link, useNavigate } from "react-router-dom";
import { isFieldWithValue } from "../utils";
import { API } from "../config/api";
import { LocalStorage } from "../config/localstorage";
import { useUser } from "../contexts/UserContext";
import Seo from "../components/seo/Seo";

const Condition = () => {
  const navigate = useNavigate();
  const { user, setUser } = useUser();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    if (user) {
      navigate("/");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user]);

  return (
    <div className="min-h-screen flex flex-col lg:flex-row">
      <Seo
        title="Conditions générales d'utilisation"
        description="Conditions générales d'utilisation de la plateforme de réservation Dalal à Dakar et partout au Sénégal."
        path="/condition"
      />
      {/* Left Section - Image */}
      <div className="lg:w-1/2 relative bg-primary">
        {/* Back button */}
        <div className="absolute top-6 left-6 z-10">
          <Link to="/">
            <button className="text-white bg-white/10 px-4 py-2 rounded-full text-sm backdrop-blur-sm">
              ← Retourner à l'accueil
            </button>
          </Link>
        </div>

        {/* Logo */}
        <div className="absolute top-6 left-6 lg:left-10">
          <img src="/logo.svg" alt="Logo" className="h-8" />
        </div>

        {/* Background Image */}
        <div className="h-[80vh] lg:h-full relative">
          <img
            src={default_image}
            alt="Desert landscape"
            className="w-full h-full object-cover"
          />
          <div className="absolute top-20 left-10 text-white">
            <h2 className="text-3xl lg:text-4xl font-light mb-4">
              Politique de confidentialité <span className="enso-bold">DALAL</span>
            </h2>
          </div>
        </div>
      </div>

      {/* Right Section - Form */}
      <div className="lg:w-1/2 p-8 lg:p-16 bg-[#1c1c24]">
        <div className="max-w-md mx-auto">
          <h1 className="text-4xl text-secondary mb-4 enso-bold">
            Bienvenue dans le monde de Dalal : Votre solution d'hébergement
            facile.
          </h1>
          <p className="text-gray-400 mb-8 enso-bold">Politique de confidentialité</p>
          <p className="text-gray-400 mb-2 enso-bold">1. Présentation</p>
          <p className="text-gray-400 mb-2 enso-bold">Qui sommes-nous ?</p>
          <p className="text-gray-400 mb-8">
            Dalal est une entreprise passionnée par le tourisme en Afrique.
            Notre mission va au-delà de simplifier la recherche d'hébergement ;
            nous aspirons à développer le tourisme local, à promouvoir
            l'authenticité et à créer des expériences uniques pour chaque
            voyageur.
          </p>
          <p className="text-gray-400 mb-8">
            Nous sommes une plateforme qui connecte les voyageurs à des
            solutions d'hébergement offrant une expérience de voyage
            authentique, chaleureuse et mémorable.
          </p>
          <p className="text-gray-400 mb-8">
            Nous ne sommes ni un hôtel, ni une maison d'hôtes, ni une SCI. Notre
            intervention est orientée à l'aide à la recherche de solutions pour
            vos besoins de séjour et à proposer des systèmes qui peuvent
            révolutionner le secteur de l'hébergement.
          </p>
          <p className="text-gray-400 mb-8">
            Nous mettons à disposition notre plateforme à toute personne ou
            entreprise responsable de son bien qu'elles consentent à publier sur
            nos plateformes. Dalal n'est pas responsable de la gestion des
            maisons d'hôtes et invite tous ses partenaires à veiller sur la
            régularité de leurs activités auprès des autorités compétentes.
          </p>
          <p className="text-gray-400 mb-2 enso-bold">
            Comment ça fonctionne ?
          </p>
          <p className="text-gray-400 mb-8">
            Dalal sert de pont entre les voyageurs curieux et les hôtes
            accueillants. Nous mettons en relation des personnes qui ont des
            chambres disponibles et qui souhaitent partager leur culture, leur
            quartier et leur hospitalité avec des voyageurs en quête d'une
            expérience locale unique grâce à notre plateforme.
          </p>
          <p className="text-gray-400 mb-2 enso-bold">
            Notre Engagement envers la Qualité
          </p>
          <p className="text-gray-400 mb-8">
            Nous sommes fiers de notre processus de sélection rigoureux qui
            garantit que chaque logement répond à des normes de qualité élevée.
            Vous pouvez avoir confiance en la propreté, le confort et la
            sécurité de chaque hébergement Dalal. Nous nous engageons à offrir
            une expérience de qualité à nos utilisateurs. Chaque partenaire est
            soigneusement sélectionné pour garantir des normes élevées
            d'hospitalité et de service.
          </p>
          <p className="text-gray-400 mb-2 enso-bold">
            Pourquoi choisir Dalal ?
          </p>
          <p className="text-gray-400 mb-8">
            * <b>Expérience Locale</b> : Vivez comme un local, grâce à
            l'expertise de nos hôtes qui partagent leurs conseils et
            recommandations. <br />* <b>Variété de Logements</b> : De la chambre
            privée confortable au loft artistique en passant par la maison
            familiale, nous avons l'hébergement parfait pour chaque voyageur.{" "}
            <br />* <b>Sécurité et Fiabilité</b> : Toutes les réservations sont
            sécurisées, et notre équipe est là pour vous soutenir à chaque étape
            de votre voyage.
          </p>
          <p className="text-gray-400 mb-2 enso-bold">Nos missions</p>
          <p className="text-gray-400 mb-8">
            Notre mission est de créer des liens humains à travers le monde.
            Nous croyons que chaque voyage devrait être une aventure qui vous
            permet de découvrir un nouveau lieu tout en vous sentant chez vous.
            C'est pourquoi nous mettons l'accent sur la convivialité,
            l'authenticité et la diversité.
          </p>
          <p className="text-gray-400 mb-8">
            Nous imaginons un avenir où chaque voyageur, quels que soient son
            origine, son budget ou ses préférences, peut accéder à une vaste
            gamme d'options d'hébergement en Afrique en toute simplicité. Nous
            pensons que chacun devrait avoir l'opportunité de découvrir la
            beauté de l'Afrique.
          </p>
          <p className="text-gray-400 mb-8">
            Notre vision englobe des moments de voyage qui laissent une
            empreinte indélébile dans le cœur de chaque voyageur. Nous
            souhaitons être le catalyseur de souvenirs inoubliables, de
            découvertes exceptionnelles et d'histoires de voyage inspirantes.
          </p>
          <p className="text-gray-400 mb-8">
            Nous incluons un engagement ferme en faveur du développement durable
            en Afrique, avec un tourisme respectueux qui contribue à la
            préservation de l'environnement et à la prospérité des populations
            locales.
          </p>
          <p className="text-gray-400 mb-2 enso-bold">Nos objectifs:</p>
          <p className="text-gray-400 mb-2">
            * <b>Créer un large réseau d'hôtes et de voyageurs.</b>
            <br />*{" "}
            <b>Rendre plus accessibles les destinations à forte attraction.</b>
            <br />*{" "}
            <b>
              Mettre en avant les aspects pouvant contribuer au développement du
              tourisme africain.
            </b>
            <br />*{" "}
            <b>
              Contribuer à organiser le secteur afin de le tirer vers la
              professionnalisation.
            </b>
            <br />
          </p>
          :
          <p className="text-yellow-400 mb-2 enso-bold">
            Acceptation des conditions de service par les utilisateurs <br />
          </p>
          <p className="text-gray-400 mb-2 enso-bold">
            2. Rechercher et réserver sur Dalal
          </p>
          <p className="text-gray-400 mb-2 enso-bold">Rechercher</p>
          <p className="text-gray-400 mb-8">
            Vous avez la possibilité de rechercher des services d'hôte en
            utilisant divers critères, notamment le type de service,
            l'emplacement et le budget de votre séjour. Les résultats sont
            classés en fonction de leur pertinence par rapport à votre demande.
          </p>
          <p className="text-gray-400 mb-2 enso-bold">Réservation</p>
          <p className="text-gray-400 mb-8">
            En effectuant une réservation, vous consentez à régler tous les
            frais liés à celle-ci, y compris le tarif de l'hébergement, les
            frais de service, les taxes et autres montants spécifiés. Une fois
            la réservation confirmée, un contrat est conclu entre vous et
            l'hôte, avec des conditions spécifiques à respecter.
          </p>
          <p className="text-gray-400 mb-2 enso-bold">Réservation</p>
          <p className="text-gray-400 mb-8">
            En effectuant une réservation, vous consentez à régler tous les
            frais liés à celle-ci, y compris le tarif de l'hébergement, les
            frais de service, les taxes et autres montants spécifiés. Une fois
            la réservation confirmée, un contrat est conclu entre vous et
            l'hôte, avec des conditions spécifiques à respecter. <br />
            Une réservation d'hébergement donne droit à un accès limité à
            l'hébergement, sous réserve de respecter les horaires et la capacité
            d'occupation autorisée par l'hôte.
          </p>
          <p className="text-gray-400 mb-2 enso-bold">
            Modifications de réservation
          </p>
          <p className="text-gray-400 mb-8">
            Les hôtes et voyageurs sont responsables de toutes les modifications
            de réservation, qu'elles soient effectuées via la plateforme Dalal
            ou demandées auprès du service client.
          </p>
          <p className="text-gray-400 mb-2 enso-bold">Vos responsabilités</p>
          <p className="text-gray-400 mb-8">
            Vous assumez l'entière responsabilité de vos actions et de celles de
            vos invités. Vous devez respecter l'état de l'hébergement et traiter
            les autres avec respect, conformément à la législation.
          </p>
          <p className="text-gray-400 mb-2 enso-bold">
            Accueil de voyageurs avec Dalal
          </p>
          <p className="text-gray-400 mb-2 enso-bold">Hôtes</p>
          <p className="text-gray-400 mb-8">
            En tant qu'hôte, Dalal vous permet de partager votre hébergement et
            générer des revenus. Vous avez le contrôle sur la manière
            d’accueillir les voyageurs, la tarification et les règles pour
            chaque annonce.
          </p>
          <p className="text-gray-400 mb-2 enso-bold">
            Contrat avec les voyageurs
          </p>
          <p className="text-gray-400 mb-8">
            Lorsqu'un voyageur réserve, un contrat est établi entre vous et lui.
            Vous êtes responsable de fournir le service conformément aux
            conditions de votre annonce.
          </p>
          <p className="text-gray-400 mb-2 enso-bold">Indépendance des Hôtes</p>
          <p className="text-gray-400 mb-8">
            Votre relation avec Dalal est indépendante. Vous n'êtes ni employé
            ni agent de Dalal, sauf pour les aspects liés à la gestion des
            paiements.
          </p>
        </div>
      </div>
    </div>
  );
};

export default Condition;
